import React from 'react';
import ReactDOM from 'react-dom';

const MODAL_ROOT_NODE_ID = 'modal-root';
const modalRoot = document.getElementById(MODAL_ROOT_NODE_ID);

export default function ModalPortal(props) {
  React.useEffect(() => {
    // Once notifications exist - blocking global scroll
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = null;
    };
  }, []);

  return ReactDOM.createPortal(props.children, modalRoot);
}
